import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import QuoteTampa from './QuoteTampa';
import shared from '../../../utils/shared.js';
import startIcon from '../../../../public/img/tampa/ui/start.png'

class AttractLoopTampa extends Component {
  constructor(props) {
    super(props);
    this._background = null;
    this._startButtonRef = null;
    this._keys = [];
  }

  componentDidMount() {
    this.startButtonAnimationLoop();
  }

  startButtonAnimationLoop = () => {
    clearTimeout(this._startButtonTimeout);
    this._startButtonTimeout = setTimeout(() => {
      if (this._startButtonRef) {
        this._startButtonRef.animate([
          {
            transform: "scale(1)",
          },
          {
            transform: "scale(1.1)",
          },
          {
            transform: "scale(1)",
          },
        ], {
          fill: "forwards",
          duration: 750
        });
      }
      this.startButtonAnimationLoop();
    }, 6000)
  }

  getRenderedModules = () => {
    let renderedModules = null;
    if (this.props.tree !== undefined && this.props.tree !== null) {
      renderedModules = this.props.tree.children.map((mod, i) => {
        this._keys[i] = mod.id;
        return (
         <QuoteTampa key={i} story={mod} useBackground={false} screen={this.props.screen}/>
        )
      });
    }

    return renderedModules;
  }

  getBackground = (displayImage) => {
    if (displayImage) {
      return shared.dp(this.props.screen, displayImage, null);
    }
    return null;
  }

  render() {
    try {
      let renderedModules = this.getRenderedModules();
      return (
        <div style={{ position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundColor: "white" }}>
          <CSSTransitionGroup
            transitionName='fastfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this._keys[this.props.attractLoopRef]} style={{ position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
              {
                renderedModules[this.props.attractLoopRef]
              }
            </div>
            <div style={{ position: "absolute", bottom: .01302083333333333333 * this.props.screen.screenHeight, display:"flex", justifyContent:"center", width:"100%" }}>
              <img src={startIcon} ref={el => this._startButtonRef = el} alt="startIcon" style={{ width: .09765625 * this.props.screen.screenHeight, height: .09765625 * this.props.screen.screenHeight }}/>
            </div>
          </CSSTransitionGroup>
        </div>
      );
    } catch(e) {
      console.log(e)
      return (<span/>)
    }
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    screen: state.screen,
  };
}

export default connect(mapStateToProps, null)(AttractLoopTampa);


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/AttractLoopTampa.jsx